
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/[year]/[month]/[day]/[slug]",
      function () {
        return require("private-next-pages/[id]/[year]/[month]/[day]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/[year]/[month]/[day]/[slug]"])
      });
    }
  